<script lang="ts">
  
  import Tab from "../../components/Tab/Tab.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import ProjectListPageProjectsTab from "./ProjectListPageProjectsTab.svelte";
  import ProjectListPageProjectActionsTab from "./ProjectListPageProjectActionsTab.svelte";
  
  enum CompanyPage {
    Project = 1,
    ProjectActions
  }
 

  let currentTab: CompanyPage = CompanyPage.Project; 
 
</script>

<MainLayout>
  <Tabs>
    <Tab
      label="Ricerca progetti"
      active={currentTab == CompanyPage.Project}
      on:click={(_) => {
        currentTab = CompanyPage.Project;
      }}
    />
    <Tab
        label="Ricerca azioni progetti"
        active={currentTab == CompanyPage.ProjectActions}
        on:click={(_) => {
          currentTab = CompanyPage.ProjectActions;
        }}
      /> 
  </Tabs>

  {#if currentTab == CompanyPage.Project}
    <ProjectListPageProjectsTab />
  {/if}

  {#if currentTab == CompanyPage.ProjectActions}
    <ProjectListPageProjectActionsTab />
  {/if}
 
</MainLayout>
